import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = {
  rule_id: string;
  enabled?: boolean;
  trigger?: string;
  response?: { type: 'text'; body: string };
  priority?: number;
};

type MutationResponse = {
  status: number;
  data: { success: boolean };
};

export const useUpdateAutoReplyMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while updating the auto-reply rule',
    endpoint: ({ rule_id }) => `/api/admin/whatsapp/auto-reply/${rule_id}`,
    method: 'PUT',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};
